import React, { useRef, useState } from "react";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import loadSCGif from "../../assets/load_SC.gif";
import {
  Table,
  TableContainer,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/Table/styles";
import Button from "../../components/Button/button";
import { Colors } from "../../shared/colors/colors";
import {
  FilterSearchDadosFinanceirosDto,
  GetDadosFinanceirosDto,
  GetDadosFinanceirosReajusteDto,
  ReajusteValoresFinanceirosDto,
} from "../../shared/dtos/DadosFinanceiros.dto";
import dadosFinanceirosService from "../../services/DadosFinanceirosService";
import { GrayTitle, StyledHR } from "../../shared/styles/global.styles";
import {
  ContainerButtons,
  EmptySearchContainer,
  EmptySearchMessage,
  LoadingContainer,
  MainContainer,
  TitleAndButton,
} from "./styles";
import { useAuth } from "../../AuthContext/AuthContext";
import { ModulosEnum } from "../../shared/enum/modulos.enum";
import { PermissoesEnum } from "../../shared/enum/permicao.enum";
import SearchModal from "./SearchModal/SearchModal";
import Pagination from "../../components/Pagination/pagination";
import { formatDateToBR } from "../../utils/dateUtils/dateUtils";
import { LoadingGif } from "./styles";
import ReajusteModal from "./ReajusteModal/ReajusteModal";
import { LiaMoneyCheckAltSolid } from "react-icons/lia";
import CadastroParcelasVariosContribuintes from "../../components/CadastroParcelasVariosContribuintes/CadastroParcelasVariosContribuintes";
import ImprimirParcelasVariosContribuintes from "../../components/ImprimirParcelasVariosContribuintes/ImprimirParcelasVariosContribuintes";

const ReajusteValoresFinanceiros = () => {
  const { checkPermission } = useAuth();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const editOnly = checkPermission(
    ModulosEnum.REAJUSTE_VALORES_FINANCEIROS,
    PermissoesEnum.ESCRITA
  );
  const readOnly = checkPermission(
    ModulosEnum.REAJUSTE_VALORES_FINANCEIROS,
    PermissoesEnum.ESCRITA
  );

  const [showSearchModal, setShowSearchModal] = useState<boolean>(false);
  const [showReajusteModal, setShowReajusteModal] = useState<boolean>(false);

  const [page, setPage] = useState<number>(1);
  const [totalDadosFinanceiros, setTotalDadosFinanceiros] = useState<number>(0);
  const [totalNewDadosFinanceiros, setTotalNewDadosFinanceiros] =
    useState<number>(0);

  const [
    showCadastroParcelasVariosContribuintes,
    setShowCadastroParcelasVariosContribuintes,
  ] = useState<boolean>(false);

  const [
    showImprimirMensalidadesVariosContribuintes,
    setShowImprimirMensalidadesVariosContribuintes,
  ] = useState<boolean>(false);

  const take = 10;
  const totalPagesDadosFinanceiros = Math.ceil(totalDadosFinanceiros / take);
  const totalPagesNewDadosFinanceiros = Math.ceil(
    totalNewDadosFinanceiros / take
  );

  const [paramsSearch, setParamsSearch] =
    useState<FilterSearchDadosFinanceirosDto>({
      dataInicioInlusao: null,
      dataFimInclusao: null,
    });
  const [dadosFinanceiros, setDadosFinanceiros] = useState<
    GetDadosFinanceirosDto[]
  >([]);
  const [newDadosFinanceiros, setNewDadosFinanceiros] = useState<
    GetDadosFinanceirosReajusteDto[]
  >([]);
  const [isRequestDadosFinanceiros, setIsRequestDadosFinanceiros] =
    useState<boolean>(false);

  const [reajusteValores, setReajusteValores] =
    useState<ReajusteValoresFinanceirosDto>({
      type: "VALUE",
      valueTitular: 0,
      valueDependente: 0,
      dateReajuste: "",
      idsDadosFinanceiros: [],
      roundValue: true,
      inputTitular: false,
      inputDependente: false,
    });

  const handlePageChange = (pageNumber: number) => {
    if (pageNumber !== page) {
      setPage(pageNumber);
    }
  };

  const getDadosFinanceirosBySearchParams = async () => {
    setIsRequestDadosFinanceiros(true);
    setReajusteValores({
      type: "VALUE",
      valueTitular: 0,
      valueDependente: 0,
      dateReajuste: "",
      idsDadosFinanceiros: [],
      roundValue: true,
    });
    setNewDadosFinanceiros([]);
    setPage(1);
    try {
      if (
        paramsSearch.dataInicioInlusao !== null &&
        paramsSearch.dataFimInclusao !== null
      ) {
        await dadosFinanceirosService
          .getBySearchParams(paramsSearch)
          .then((response) => {
            setDadosFinanceiros(response);
            setTotalDadosFinanceiros(response.length);
          })
          .catch((error) => {
            console.error("Erro ao buscar dados financeiros:", error);
            Swal.fire({
              title: "Erro",
              text: "Ocorreu um erro ao buscar os dados financeiros. Por favor, tente novamente.",
              icon: "error",
              confirmButtonText: "Fechar",
              allowOutsideClick: false,
            });
          });
      }
    } catch (error) {
      console.error("Erro ao buscar dados financeiros:", error);
      Swal.fire({
        title: "Erro",
        text: "Ocorreu um erro ao buscar os dados financeiros. Por favor, tente novamente.",
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
    setIsRequestDadosFinanceiros(false);
  };

  const formatarValorEmReais = (valor: string) => {
    if (!valor) return "R$ 0,00";

    // Se o valor já estiver no formato numérico com ponto como separador decimal, converte diretamente para número
    const numero = parseFloat(valor.replace(",", "."));

    // Verifica se o valor é um número válido
    if (isNaN(numero)) return "R$ 0,00";

    // Formata o número para reais com separadores corretos
    return numero.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const handleReajuste = (reajusteData: ReajusteValoresFinanceirosDto) => {
    if (dadosFinanceiros) {
      const newDadosFinanceiros: GetDadosFinanceirosReajusteDto[] = [];
      for (const data of dadosFinanceiros) {
        newDadosFinanceiros.push({
          ...data,
          newDadoFinanceiro: false,
          deletedDadoFinanceiro: true,
          dataExclusao: reajusteData.dateReajuste,
        });

        newDadosFinanceiros.push({
          ...data,
          newDadoFinanceiro: true,
          deletedDadoFinanceiro: false,
          valorTitular: reajusteData.valueTitular
            ? calculateChargeValue(
                reajusteData.type,
                reajusteData.valueTitular,
                Number(data.valorTitular),
                reajusteData.roundValue
              ).toString()
            : data.valorTitular,
          valorDependente: reajusteData.valueDependente
            ? calculateChargeValue(
                reajusteData.type,
                reajusteData.valueDependente,
                Number(data.valorDependente),
                reajusteData.roundValue
              ).toString()
            : data.valorDependente,
          dataInclusao: reajusteData.dateReajuste,
        });
      }
      setNewDadosFinanceiros(newDadosFinanceiros);
      setTotalNewDadosFinanceiros(newDadosFinanceiros.length);
      setPage(1);
    }
  };

  const calculateChargeValue = (
    type: "PERCENTAGE" | "VALUE",
    reajusteValue: number,
    value: number,
    roundValue: boolean
  ) => {
    if (type === "PERCENTAGE") {
      const formatReajusteValue = reajusteValue / 100;
      const percentageValue = value * (formatReajusteValue / 100);
      const total = value + percentageValue;
      return roundValue ? Math.ceil(total) : total;
    } else {
      const formatReajusteValue = reajusteValue / 100;
      return roundValue ? Math.ceil(formatReajusteValue) : formatReajusteValue;
    }
  };

  const handleSubmit = async (reajusteData: ReajusteValoresFinanceirosDto) => {
    // Show confirmation dialog before proceeding with adjustment
    const result = await Swal.fire({
      title: "Confirmação",
      text: "Deseja realmente realizar o reajuste dos valores?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      allowOutsideClick: false,
    });

    if (!result.isConfirmed) {
      return;
    }
    const reajusteValores = {
      ...reajusteData,
      idsDadosFinanceiros: dadosFinanceiros.map((data) => data.id),
    };

    // Show loading alert while processing adjustment
    Swal.fire({
      title: "Aguarde",
      text: "Efetuando os ajustes...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await dadosFinanceirosService
      .reajusteValoresFinanceiros(reajusteValores)
      .then((response) => {
        if (response.success) {
          Swal.fire({
            title: "Sucesso",
            text: "Reajuste de valores realizado com sucesso.",
            icon: "success",
            confirmButtonText: "Fechar",
            allowOutsideClick: false,
          });
          setNewDadosFinanceiros([]);
          setDadosFinanceiros([]);
          setReajusteValores({
            type: "VALUE",
            valueTitular: 0,
            valueDependente: 0,
            dateReajuste: "",
            idsDadosFinanceiros: [],
            roundValue: true,
          });
          setShowReajusteModal(false);
          setShowSearchModal(false);
        } else {
          Swal.fire({
            title: "Erro",
            text: "Ocorreu um erro ao reajustar os valores. Por favor, tente novamente.",
            icon: "error",
            confirmButtonText: "Fechar",
            allowOutsideClick: false,
          });
        }
      });
  };

  return (
    <MainContainer>
      <TitleAndButton>
        <GrayTitle>Reajuste e parcelas</GrayTitle>
        <ContainerButtons ref={wrapperRef}>
          {editOnly && (
            <>
              <Button
                schemaButton="full-primary"
                action={() => {
                  setShowSearchModal(true);
                }}
              >
                Buscar dados financeiros para reajuste
              </Button>
              <Button
                schemaButton="out-primary"
                action={() => setShowCadastroParcelasVariosContribuintes(true)}
              >
                Cadastrar parcelas para todos contribuintes
              </Button>
              <Button
                schemaButton="out-primary"
                action={() =>
                  setShowImprimirMensalidadesVariosContribuintes(true)
                }
              >
                Imprimir parcelas para todos os contribuintes
              </Button>
            </>
          )}
        </ContainerButtons>
      </TitleAndButton>
      <StyledHR />

      {dadosFinanceiros ? (
        <>
          <ContainerButtons ref={wrapperRef}>
            {editOnly && dadosFinanceiros.length > 0 && (
              <Button
                schemaButton={
                  newDadosFinanceiros && newDadosFinanceiros?.length > 0
                    ? "out-primary"
                    : "full-primary"
                }
                action={() => {
                  setShowReajusteModal(true);
                }}
              >
                {newDadosFinanceiros && newDadosFinanceiros.length > 0
                  ? "Ajustar dados de reajuste"
                  : "Lançar dados de reajuste"}
              </Button>
            )}
            {newDadosFinanceiros && newDadosFinanceiros.length > 0 && (
              <Button
                schemaButton="full-primary"
                action={() => {
                  handleSubmit(reajusteValores);
                }}
              >
                Realizar reajuste
              </Button>
            )}
          </ContainerButtons>

          <TableContainer>
            {isRequestDadosFinanceiros ? (
              <LoadingContainer>
                <LoadingGif src={loadSCGif} alt="Carregando..." />
              </LoadingContainer>
            ) : (
              <Table id="dados-financeiros-tabela">
                <TableHead>
                  <TableRow
                    style={{
                      backgroundColor: Colors.primary,
                      color: Colors.white,
                    }}
                  >
                    <TableHeader>Contribuinte</TableHeader>
                    <TableHeader>Data de Inclusão</TableHeader>
                    <TableHeader>Dt.Incl.Dados Financeiros</TableHeader>
                    <TableHeader>Dt.Excl. Dados Financeiros</TableHeader>
                    <TableHeader>Lotação</TableHeader>
                    <TableHeader>Valor titular</TableHeader>
                    <TableHeader>Valor dependente</TableHeader>
                  </TableRow>
                </TableHead>
                <tbody>
                  {newDadosFinanceiros && newDadosFinanceiros.length > 0 ? (
                    newDadosFinanceiros
                      .slice((page - 1) * take, page * take)
                      .map((dados, idx) => (
                        <React.Fragment key={`dados-financeiros-${idx}`}>
                          <TableRow>
                            {/* Contribuinte */}
                            <TableData
                              style={{
                                fontWeight: dados.newDadoFinanceiro
                                  ? "bold"
                                  : "normal",
                                color: dados.newDadoFinanceiro
                                  ? "green"
                                  : dados.deletedDadoFinanceiro
                                  ? "red"
                                  : "inherit",
                              }}
                            >
                              {dados.contribuinte?.nome || "-"}
                            </TableData>

                            {/* Data de Inclusão */}
                            <TableData
                              style={{
                                fontWeight: dados.newDadoFinanceiro
                                  ? "bold"
                                  : "normal",
                                color: dados.newDadoFinanceiro
                                  ? "green"
                                  : dados.deletedDadoFinanceiro
                                  ? "red"
                                  : "inherit",
                              }}
                            >
                              {dados.contribuinte?.movimentacoes?.[0]
                                ?.data_movimentacao
                                ? formatDateToBR(
                                    dados.contribuinte.movimentacoes[0]
                                      .data_movimentacao
                                  )
                                : "-"}
                            </TableData>

                            {/* Dt.Incl.Dados Financeiros */}
                            <TableData
                              style={{
                                fontWeight: dados.newDadoFinanceiro
                                  ? "bold"
                                  : "normal",
                                color: dados.newDadoFinanceiro
                                  ? "green"
                                  : dados.deletedDadoFinanceiro
                                  ? "red"
                                  : "inherit",
                              }}
                            >
                              {dados.dataInclusao
                                ? formatDateToBR(dados.dataInclusao)
                                : "-"}
                            </TableData>

                            {/* Dt.Excl. Dados Financeiros */}
                            <TableData
                              style={{
                                fontWeight: dados.newDadoFinanceiro
                                  ? "bold"
                                  : "normal",
                                color: dados.newDadoFinanceiro
                                  ? "green"
                                  : dados.deletedDadoFinanceiro
                                  ? "red"
                                  : "inherit",
                              }}
                            >
                              {dados.dataExclusao
                                ? formatDateToBR(dados.dataExclusao)
                                : "-"}
                            </TableData>

                            {/* Lotação */}
                            <TableData
                              style={{
                                fontWeight: dados.newDadoFinanceiro
                                  ? "bold"
                                  : "normal",
                                color: dados.newDadoFinanceiro
                                  ? "green"
                                  : dados.deletedDadoFinanceiro
                                  ? "red"
                                  : "inherit",
                              }}
                            >
                              {dados.lotacao?.descricao || "-"}
                            </TableData>

                            {/* Valor titular */}
                            <TableData
                              style={{
                                fontWeight: dados.newDadoFinanceiro
                                  ? "bold"
                                  : "normal",
                                color: dados.newDadoFinanceiro
                                  ? "green"
                                  : dados.deletedDadoFinanceiro
                                  ? "red"
                                  : "inherit",
                              }}
                            >
                              {dados.valorTitular
                                ? formatarValorEmReais(dados.valorTitular)
                                : "-"}
                            </TableData>

                            {/* Valor dependente */}
                            <TableData
                              style={{
                                fontWeight: dados.newDadoFinanceiro
                                  ? "bold"
                                  : "normal",
                                color: dados.newDadoFinanceiro
                                  ? "green"
                                  : dados.deletedDadoFinanceiro
                                  ? "red"
                                  : "inherit",
                              }}
                            >
                              {dados.valorDependente
                                ? formatarValorEmReais(dados.valorDependente)
                                : "-"}
                            </TableData>
                          </TableRow>
                          {(idx + 1) % 2 === 0 && (
                            <TableRow>
                              <TableData
                                colSpan={7}
                                style={{ padding: "0.5rem" }}
                              />
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))
                  ) : dadosFinanceiros.length > 0 ? (
                    dadosFinanceiros
                      .slice((page - 1) * take, page * take)
                      .map((dados, idx) => (
                        <TableRow key={`dados-financeiros-${idx}`}>
                          {/* Contribuinte */}
                          <TableData>
                            {dados.contribuinte?.nome
                              ? dados.contribuinte?.nome
                              : "-"}
                          </TableData>
                          {/* Data de Inclusão */}
                          <TableData>
                            {dados.contribuinte &&
                            dados.contribuinte?.movimentacoes &&
                            dados.contribuinte?.movimentacoes[0]
                              ?.data_movimentacao
                              ? formatDateToBR(
                                  dados.contribuinte?.movimentacoes[0]
                                    ?.data_movimentacao
                                )
                              : "-"}
                          </TableData>
                          {/* Dt.Incl.Dados Financeiros */}
                          <TableData>
                            {dados.dataInclusao
                              ? formatDateToBR(dados.dataInclusao)
                              : "-"}
                          </TableData>
                          {/* Dt.Excl. Dados Financeiros */}
                          <TableData>
                            {dados.dataExclusao
                              ? formatDateToBR(dados.dataExclusao)
                              : "-"}
                          </TableData>
                          {/* Lotação */}
                          <TableData>
                            {dados.lotacao !== null
                              ? dados.lotacao?.descricao
                              : "-"}
                          </TableData>
                          {/* Valor titular */}
                          <TableData>
                            {dados.valorTitular
                              ? formatarValorEmReais(dados.valorTitular)
                              : "-"}
                          </TableData>
                          {/* Valor dependente */}
                          <TableData>
                            {dados.valorDependente
                              ? formatarValorEmReais(dados.valorDependente)
                              : "-"}
                          </TableData>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableData colSpan={7} className="text-center text-muted">
                        Não foi encontrado nenhum dado financeiro
                      </TableData>
                    </TableRow>
                  )}
                </tbody>
              </Table>
            )}
          </TableContainer>
          {newDadosFinanceiros &&
          newDadosFinanceiros.length > 0 &&
          totalPagesNewDadosFinanceiros >= 2 ? (
            <Pagination
              currentPage={page}
              totalPages={totalPagesNewDadosFinanceiros}
              onPageChange={handlePageChange}
            />
          ) : (
            dadosFinanceiros &&
            dadosFinanceiros.length > 0 &&
            totalPagesDadosFinanceiros >= 2 && (
              <Pagination
                currentPage={page}
                totalPages={totalPagesDadosFinanceiros}
                onPageChange={handlePageChange}
              />
            )
          )}
        </>
      ) : (
        <EmptySearchContainer>
          <EmptySearchMessage>
            Por favor, utilize "Buscar dados financeiros".
          </EmptySearchMessage>
        </EmptySearchContainer>
      )}
      {showSearchModal && (
        <SearchModal
          show={showSearchModal}
          paramsSearch={paramsSearch}
          setParamsSearch={setParamsSearch}
          onClose={() => setShowSearchModal(false)}
          onSubmit={() => getDadosFinanceirosBySearchParams()}
        />
      )}
      {showReajusteModal && (
        <ReajusteModal
          show={showReajusteModal}
          reajusteValores={reajusteValores}
          setReajusteValores={setReajusteValores}
          onClose={() => setShowReajusteModal(false)}
          onSubmit={(reajusteData) => handleReajuste(reajusteData)}
        />
      )}
      {showCadastroParcelasVariosContribuintes && editOnly && (
        <CadastroParcelasVariosContribuintes
          onClose={() => setShowCadastroParcelasVariosContribuintes(false)}
          show={showCadastroParcelasVariosContribuintes}
        />
      )}

      {showImprimirMensalidadesVariosContribuintes && editOnly && (
        <ImprimirParcelasVariosContribuintes
          onClose={() => setShowImprimirMensalidadesVariosContribuintes(false)}
          show={showImprimirMensalidadesVariosContribuintes}
        />
      )}
    </MainContainer>
  );
};

export default ReajusteValoresFinanceiros;
